<template>
  <!-- CPAP 患者情報詳細 -->
  <div id="CpapPatientDetail">
    <div :id="getContainerType()">
      <div class="labelTitle lable">CPAP 患者詳細</div>
      <div class="button-area">

        <template v-if="isOutPut(targetData.applicationType,'転院中') && !(this.isHospital || this.isDealer) && !targetData.transferDestinationName"><!--営業/代理の場合-->
          <button class="button is-primary" type="button" slot="trigger" @click="changeHospital(true)">
            <b-icon icon="hospital-building"></b-icon>
            <span>転院先設定</span>
          </button>
        </template>
        <template v-else-if="isOutPut(targetData.applicationType,'転院中') && !(this.isHospital || this.isDealer)">
          <button class="button is-primary" type="button" slot="trigger" @click="changeHospital(true)">
            <b-icon icon="hospital-building"></b-icon>
            <span>転院先変更</span>
          </button>
        </template>
        <!-- <template v-if="isOutPut(targetData.applicationType,'転入予定') ">営業/代理の場合 -->
        <template v-if="isOutPut(targetData.applicationType,'転入予定') && !(this.isHospital || this.isDealer)">
          <button class="button is-primary" type="button" slot="trigger" @click="changeHospital(true)">
            <b-icon icon="hospital-building"></b-icon>
            <span>転院先変更</span>
          </button>
        </template>
        <template v-if="isOutPut(targetData.applicationType,'転院先未定') && !(this.isHospital || this.isDealer)"><!--代理の場合-->
          <button class="button is-primary" type="button" slot="trigger" @click="changeHospital(true)">
            <b-icon icon="hospital-building"></b-icon>
            <span>転院先設定</span>
          </button>
        </template>
        <template v-else-if="!targetData.applicationChangeValue && !targetData.applicationResumeValue && isOutPut(targetData.applicationType,'処方中')">
          <button v-if="!targetData.applicationReturnedValue" class="button is-primary" type="button" slot="trigger" @click="changeHospital(false)">
            <b-icon icon="clipboard-arrow-right"></b-icon>
            <span>転院</span>
          </button>
          <button v-if="!targetData.applicationChangeValue && !targetData.applicationResumeValue" class="button is-primary" type="button" slot="trigger" @click="edit">
            <b-icon icon="clipboard-edit"></b-icon>
            <span v-if="isEscrow">預託処方変更</span>
            <span v-else>処方変更</span>
          </button>
          <button v-if="!targetData.applicationChangeValue && !targetData.applicationResumeValue" class="button is-primary" type="button" slot="trigger" @click="cancel">
            <b-icon icon="clipboard-remove"></b-icon>
            <span>処方中止</span>
          </button>
        </template>
        <template v-else-if="!targetData.applicationChangeValue && !targetData.notApplicationResume && !targetData.applicationResumeValue && !targetData.applicationReturnedValue && (isOutPut(targetData.applicationType,'処方中止') || isOutPut(targetData.applicationType,'転入予定'))">
          <template v-if="!(isEscrow && progress == 5)">
            <!-- 預託転院患者を預託処方再開することはできない（仮持出IDの付与が必要なため。フィリップス佐藤様）※progress == 5 →　転入予定 -->
            <button class="button is-primary" type="button" slot="trigger" @click="requestAgain">
              <b-icon icon="clipboard-pulse"></b-icon>
              <span v-if="isEscrow">預託処方再開</span>
              <span v-else>処方再開</span>
            </button>
          </template>
        </template>
        <!-- QA418 転院から処方中止に変更 -->
        <template v-if="((isOutPut(targetData.applicationType,'転入予定') || isOutPut(targetData.applicationType,'転院先未定')) && (this.targetData.status == 12 || this.targetData.status == 14)) && !(this.isHospital || this.isDealer)">
          <button class="button is-primary" style="width:220px;" type="button" slot="trigger" @click="transferCancel">
            <b-icon icon="clipboard-remove"></b-icon>
            <span>処方中止申込みへ変更</span>
          </button>
        </template>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
        <b-button class="pdfbutton is-primary" v-if="(!isDealer && pdfDisplay && ((targetData.reportFormatType == 1 || targetData.reportFormatType == 2 || targetData.reportFormatType == 3 || targetData.reportFormatType == 4) && (targetData.applicationType == 1 || targetData.applicationType == 2 || targetData.applicationType == 3 || targetData.applicationType == 4 || targetData.applicationType == 5)))" icon-left="printer" v-on:click="downloadInstructionsPDF">署名欄付き指示書PDF</b-button>
      </div>
      <div id="item-contens">
        <cpapRequestDetail :data="targetData" :innerUser="!isHospital && !isDealer" :showRequestInfo="!isHospital && !isDealer" :progress="targetData.applicationType" :patientDetailsFlag='false' :isEdit="mode=='edit'||targetData.isTransferUndecided" v-on:back="back" :isShowProject="true" :isPatientDetail="true"/>
        <div class="button-area">
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {extUserStatus,cpapRequestStatus} from "@/components/mock/base/const.js";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";

export default {
  name: "CpapPatientDetail",
  methods: {
    getContainerType: function(){
      let type = "container";
      if(this.isHospital || this.isDealer){
        type = "container-center"
      }
      return type;
    },
    back: function() {
      let target = "CpapAgentPatientList";
      if(this.isHospital || this.isDealer){
        target = "CpapPatientList"
      }
      this.$router.push({
        name: target,
        params: { searchConditions: this.searchParams, temp:this.temp, isEscrow:this.$route.params["isEscrow"]},
      });
    },
    isOutPut: function(code,targetValue) {
      var flg = false
      var target = this.progressList.find(val => val.code == code)
      if(target && targetValue.indexOf(target.name) != -1){
        flg = true
      }
      return flg
    },
    doSearch: function() {
      var excuteApi = this.getCpapPatientDetailsPOST;
      var successCallBack = this.getCpapPatientDetailsPOSTSuccess;
      var errorCallBack = this.getCpapPatientDetailsPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapPatientDetailsPOST: function(client) {
      return client.apis.externalCpap.getCpapPatientDetailsPOST({
        body:{id:this.searchId}
      });
    },
    getCpapPatientDetailsPOSTSuccess: function(result) {
      // 検索結果取得
      this.targetData = result.obj
      this.mode = "show";
      var progress = this.getCpapProgres(this.targetData.status)
      if(progress.indexOf("仮受付") != -1) {
        this.mode = "edit";
      }
    },
    getCpapPatientDetailsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result.message,this.back());
    },
    changeHospital: function(appliedFlg) {
      // 転院画面に遷移
      var reqData = JSON.parse(JSON.stringify(this.targetData));
      // QA401 最新情報に更新
      reqData.medicalInstitutionCode = this.targetData.newMedicalInstitutionCode
      reqData.medicalInstitutionName = this.targetData.newMedicalInstitutionName
      if (this.isHospital || this.isDealer) {
        this.$router.push({ 
          name: "CpapHospitalTransfer",
          params: { selectedData: reqData, targetId:this.searchId, searchConditions: this.searchParams, isApplied:appliedFlg, isEscrow:this.$route.params["isEscrow"]}
        });
      } else {
        this.$router.push({ 
          name: "CpapAgentHospitalTransfer",
          params: { selectedData: reqData, targetId:this.searchId, searchConditions: this.searchParams, temp:this.temp, isApplied:appliedFlg, isEscrow:this.$route.params["isEscrow"]}
        });
      }
    },
    edit: function() {
      // 処方変更画面に遷移
      var reqData = JSON.parse(JSON.stringify(this.targetData));
      reqData.depositUseFlag = false
      reqData.provisionalTakenOutItems = []
      reqData.billingStartDate = this.yyyy_hyp_MM_hyp_dd(new Date())
      // QA401 最新情報に更新
      reqData.medicalInstitutionCode = this.targetData.newMedicalInstitutionCode
      reqData.medicalInstitutionName = this.targetData.newMedicalInstitutionName

      if (this.isHospital || this.isDealer) {
        this.$router.push({
          name: "CpapInstrumentDetail",
          params: { selectedData: reqData, targetId:this.searchId, searchConditions: this.searchParams, name:"CpapPatientDetail", resume:true, isEscrow:this.$route.params["isEscrow"]},
        });
      } else {
        this.$router.push({
          name: "CpapAgentInstrumentDetail",
          params: { selectedData: reqData, targetId:this.searchId, searchConditions: this.searchParams, name:"CpapAgentPatientDetail", resume:true, temp:this.temp, isEscrow:this.$route.params["isEscrow"]},
        });
      }
    },
    cancel: function() {
      // 処方中止画面に遷移
      var reqData = JSON.parse(JSON.stringify(this.targetData));
      reqData.contractEndDate = this.yyyy_hyp_MM_hyp_dd(new Date())
      // QA401 最新情報に更新
      reqData.medicalInstitutionCode = this.targetData.newMedicalInstitutionCode
      reqData.medicalInstitutionName = this.targetData.newMedicalInstitutionName
      reqData.receiverName = this.targetData.newMedicalInstitutionName
      if (this.isHospital || this.isDealer) {
        this.$router.push({
          name: "CpapCancelDetail",
          params: { selectedData: reqData, targetId:this.searchId, searchConditions: this.searchParams, name:"CpapPatientDetail", resume:true, isEscrow:this.$route.params["isEscrow"]},
        });
      } else {
        this.$router.push({
          name: "CpapAgentCancelDetail",
          params: { selectedData: reqData, targetId:this.searchId, searchConditions: this.searchParams, name:"CpapAgentPatientDetail", resume:true, temp:this.temp, isEscrow:this.$route.params["isEscrow"]},
        });
      }
    },
    requestAgain: function() {
      // 処方再開画面に遷移
      var reqData = JSON.parse(JSON.stringify(this.targetData));
      if(this.isOutPut(reqData.applicationType,'処方中止')){
        // 中止後再開の場合、シリアルをクリアする
        reqData.serial = ""
        reqData.moistSerial = ""
        reqData.moduleSerial = ""
      }
      // QA401 最新情報に更新
      reqData.medicalInstitutionCode = this.targetData.newMedicalInstitutionCode
      reqData.medicalInstitutionName = this.targetData.newMedicalInstitutionName
      reqData.receiverName = this.targetData.newMedicalInstitutionName
      if ((this.isHospital || this.isDealer) && !this.isEscrow) {
        this.$router.push({
          name: "CpapRequest",
          params: { selectedData: reqData, targetId:this.searchId, searchConditions: this.searchParams, name:"CpapPatientDetail", resume:this.isOutPut(reqData.applicationType,'転入予定'), cancelResume:this.isOutPut(reqData.applicationType,'処方中止')},
        });
      } else if (!(this.isHospital || this.isDealer) && !this.isEscrow) {
        this.$router.push({
          name: "CpapAgentRequest",
          params: { selectedData: reqData, targetId:this.searchId, searchConditions: this.searchParams, name:"CpapAgentPatientDetail", resume:this.isOutPut(reqData.applicationType,'転入予定'), cancelResume:this.isOutPut(reqData.applicationType,'処方中止'), temp:this.temp},
        });
      } else if (this.isEscrow) {
        this.$router.push({
          name: "CpapRequest",
          params: { selectedData: reqData, targetId:this.searchId, searchConditions: this.searchParams, name:"CpapPatientDetail", resume:this.isOutPut(reqData.applicationType,'転入予定'), cancelResume:this.isOutPut(reqData.applicationType,'処方中止'), instrument:true , isEscrow:true},
        });
      }
    },
    transferCancel: function() {
      // QA418 転院から処方中止申込みに変更
      this.$dialog.confirm({
        title: "　",
        message: "「転院申込み」から「処方中止申込み」へ変更します。<br>よろしいですか？",
        cancelText: "キャンセル",
        onConfirm: () => {
          // 処方中止の支店回覧に移動
          var reqData = JSON.parse(JSON.stringify(this.targetData));
          var isTransferCancel = true
          var kind = 'Cancel'
          this.$router.push({
            name:'CpapRequestDetail',
            params:{
              receiptNumber: reqData.receiptNumber,
              targetId: this.searchId,
              kind: kind,
              status: cpapRequestStatus.request,
              searchConditions: this.searchParams,
              isTemp: this.temp,
              isTransferCancel: isTransferCancel
            }
          });
        },
      });
    },
    downloadInstructionsPDF: function(){
      var _this = this;
      this.downloadApiCall(function(client){
          return client.apis.apiCommon.getInstructionsPDFPOST({
            body:{receiptNumber:_this.targetData.receiptNumber}
          })
        },
        function(message) {
          _this.showErrorMessage(message);
        }
      );
    }
  },
  data() {
    var searchId = this.$route.params["targetId"];
    var searchParams = this.$route.params["searchConditions"];
    // 仮持出申込み判定
    var temp = false;
    if(this.$route.params["temp"]){
      temp = this.$route.params["temp"];
    }
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    var progressList = this.getCpapManagementStatusList();
    let isEscrow = this.$route.params["isEscrow"];
    let progress = this.$route.params["progress"];
    let pdfDisplay = this.$route.params["pdfDisplay"];
    return {
      searchParams,
      temp,
      targetData: {},
      searchId,
      roleId: roleId,
      userId: userId,
      isHospital: isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      role: role,
      extUserStatus: extUserStatus,
      progressList,
      mode:"",
      isEscrow,
      progress,
      pdfDisplay
    };
  },
  filters: {},
  components: {
    cpapRequestDetail:CpapRequestDetail
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  }
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
a {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapPatientDetail.vue